import { Container, Spinner } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import { usePage } from "../../hooks/usePage";
import { usePrecargaEvents } from "../../hooks/usePrecargaEvents";

export default function Precargas() {
  usePage({ title: "Precargas" });
  
  const { eventid } = useParams();
  const cashlessEventId = eventid ? parseInt(eventid) : null;

  // Get precarga event for this cashless event
  const { isLoadingPrecargaEvent, hasPrecargaEvent } = usePrecargaEvents({
    cashlessEventId,
  });

  if (isLoadingPrecargaEvent) {
    return (
      <Container fluid>
        <div className="text-center p-5">
          <Spinner animation="border" />
          <p className="mt-3">Cargando configuración de precarga...</p>
        </div>
      </Container>
    );
  }

  if (!eventid) {
    return null;
  }

  return (
    <Navigate
      to={`/${eventid}/preloads/${hasPrecargaEvent ? "detail" : "create"}`}
      replace
    />
  );
}